import { render } from "./SegmentValuesDialog.vue?vue&type=template&id=319efa40"
import script from "./SegmentValuesDialog.vue?vue&type=script&lang=ts"
export * from "./SegmentValuesDialog.vue?vue&type=script&lang=ts"

import "./SegmentValuesDialog.vue?vue&type=style&index=0&id=319efa40&lang=scss"
script.render = render

export default script